import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject, timer } from 'rxjs';
import { map, mergeMap, takeUntil } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { CarouselType } from 'src/app/layouts/banner-manager/banner-manager.service';
import { LeftMenuService } from 'src/app/layouts/left-menu/left-menu.service';
import { ImgCarouselOptions } from 'src/app/shared/components/img-carousel/img-carousel-options.interface';
import { GameListItem, ProviderInterface } from 'src/app/shared/interfaces/game.interface';
import { CollectorService } from 'src/app/shared/service/collector.service';
import { DataCollectionService } from 'src/app/shared/service/data-collection.service';
import { LayoutService } from 'src/app/shared/service/layout.service';
import { LocaleService } from 'src/app/shared/service/locale.service';
import { MiniGameService } from '../minigame/minigame.service';
import { WalletService } from '../wallet/wallet.service';
@UntilDestroy()
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  protected readonly CarouselType = CarouselType;

  constructor(
    public appService: AppService,
    public collectorService: CollectorService,
    private router: Router,
    private miniGameService: MiniGameService,
    private leftMenuService: LeftMenuService,
    private dataCollectionService: DataCollectionService,
    private route: ActivatedRoute,
    private walletService: WalletService,
    private localeService: LocaleService,
    private layout: LayoutService,
  ) {}

  isH5!: boolean;
  domain = window.location.origin;
  logined: boolean = false;
  /** 当前登录的用户名 */
  username: string = '';
  /** 首页标签数据 */
  labelList: any[] = [];
  providers: ProviderInterface[] = [];
  lang: string = '';
  rebateTxt: string = '';

  /**滚动与断点配置 */
  imgCarouselConfig: ImgCarouselOptions = {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 10,
    speed: 500,
    breakpoints: {
      1400: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      800: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
    },
  };
  periodYears: string = '';

  updatedFavoriteIds = this.miniGameService.allFavoriteIds$.pipe(untilDestroyed(this)).subscribe(ids => {
    const gameLists: GameListItem[] | undefined = this.labelList[0]?.gameLists || [];
    if (!gameLists) return;
    gameLists.forEach((item: GameListItem) => {
      item.isFavorite = ids.includes(item.id);
    });
  });

  ngOnInit() {
    this.periodYears = (new Date().getFullYear() - 2006).toString();
    this.setPoint('in');
    this.appService.userInfo$.pipe(untilDestroyed(this)).subscribe(v => {
      this.logined = !!v;
      if (this.logined) {
        this.username = v?.userName ?? (v?.uid || '');
      }
    });
    this.lang = this.appService.languageCode;
    this.initGameListByLabel();
    this.rebateTxt = this.localeService.getValue('up_to_rebate').replace('${0}', '1.28%');

    this.layout.isH5$.pipe(untilDestroyed(this)).subscribe(bool => (this.isH5 = bool));
    this.layout
      .watchPageReuse('')
      .pipe(untilDestroyed(this))
      .subscribe(x => {
        switch (x.type) {
          case 'enter':
            this.setPoint('in');
            break;
          case 'leave':
            this.setPoint('out');
            break;
          default:
            break;
        }
      });
  }

  /**
   * 初始化首页游戏标签数据
   */
  initGameListByLabel() {
    this.leftMenuService
      .onGetTags()
      .pipe(
        untilDestroyed(this),
        map(v => v?.headerMenus?.filter(x => x.key === '0')[0]?.infoVerticallyList || []),
        mergeMap(homeGameResult => {
          const labelCodes = homeGameResult.map(result => result.labelCode);
          return this.miniGameService.getGameListByLabelIds(labelCodes).pipe(
            untilDestroyed(this),
            map(gameListResult => {
              return homeGameResult?.map(homeGames => {
                const gameLists = gameListResult?.find(gameItem => gameItem?.labelId === homeGames?.labelId)?.gameList;
                return {
                  ...homeGames,
                  gameLists,
                  gameCount: gameLists?.length || 0,
                  configUrl: this.leftMenuService.getLinkByMethod(homeGames),
                };
              });
            }),
          );
        }),
      )
      .subscribe(data => {
        this.labelList = data || [];
      });

    if (this.providers.length < 1) {
      this.miniGameService
        .getAllProvider()
        .pipe(untilDestroyed(this))
        .subscribe(data => (this.providers = data));
    }
  }

  /**
   * 普通跳转
   *
   * @param path 跳转的路由
   */
  jumpTo(path: string) {
    this.router.navigateByUrl(`${this.appService.languageCode}/${path}`);
  }

  /**
   * 点击供应商
   *
   * @param item
   */
  // clickProviderItem(item: GameListItem) {
  //   this.router.navigateByUrl(`${this.appService.languageCode}/casino/provider/${item.providerCatId}`);
  // }

  /**
   * 点击标签
   *
   * @param item
   * @param item.code
   */
  clickLabelItem(item: { code: string }) {
    this.router.navigateByUrl(`${this.appService.languageCode}/casino/category/${item.code}`);
  }

  ngOnDestroy(): void {
    this.setPoint('out');
  }

  /**
   * 注册出框
   */
  openRegisterDialog(): void {
    // this.appService.openLazyComponentDialog('RegisterComponent', { type: 'register' });
    this.router.navigate([], { relativeTo: this.route, fragment: 'register' });
  }

  /**
   * 打开存款弹窗
   */
  openDepositDialog(): void {
    this.walletService.popupOpen(this.appService.currentCurrency$.value.currency, 'd-fiat');
  }

  /**
   * 打开购买虚拟货币弹窗
   */
  openBuyCryptoDialog(): void {
    let currency = this.appService.currentCurrency$.value.currency;
    currency = this.appService.currentCurrency$.value.isDigital && currency != 'LED' ? currency : 'USDT';
    this.walletService.popupOpen(currency, 'purchase');
  }

  /* --------------------------------- App下载相关 START-------------------------------- */
  qrPopPositions: ConnectedPosition[] = [
    {
      originX: 'center',
      originY: 'bottom',
      overlayX: 'center',
      overlayY: 'top',
      panelClass: 'app-download-qr-pop-down',
    },
    { originX: 'center', originY: 'top', overlayX: 'center', overlayY: 'bottom', panelClass: 'app-download-qr-pop-up' },
  ];

  showPop$: Subject<boolean> = new Subject();
  downQR: boolean = false;
  showPop(skipRepeat: boolean = true) {
    if (skipRepeat && this.downQR) return;
    this.closePop();
    this.showPop$.next(true);
    this.downQR = true;
  }

  closePop(time: number = 0) {
    if (time > 0) {
      timer(time)
        .pipe(takeUntil(this.showPop$))
        .subscribe(_ => {
          this.downQR = false;
        });
    } else {
      this.downQR = false;
    }
  }

  /**
   * 打开新窗口下载App
   */
  downloadApp() {
    this.collectorService.sendAppInviteCode();
    window.open(this.appService.getAppUrl(), '_blank');
  }
  /* --------------------------------- App下载相关 END-------------------------------- */

  setPoint(type: string) {
    switch (type) {
      case 'in':
        this.dataCollectionService.addPoint({ eventId: 30001 });
        this.dataCollectionService.setEnterTime('home');
        break;
      case 'out':
        this.dataCollectionService.addPoint({
          eventId: 30002,
          actionValue1: this.dataCollectionService.getTimDiff('home'),
          actionValue2: 0,
        });
        break;
      default:
        break;
    }
  }
}
